var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_983_3273)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.00195312,
    width: 16.3987,
    height: 16.3987,
    rx: 8.19936,
    fill: "#5FC56D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.94043,
    y: 0.938843,
    width: 14.5192,
    height: 14.5192,
    rx: 7.25962,
    fill: "url(#paint0_linear_983_3273)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.94043,
    y: 0.938843,
    width: 14.5192,
    height: 14.5192,
    rx: 7.25962,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.56055,
    y: 3.73401,
    width: 1.53866,
    height: 8.46264,
    rx: 0.235073,
    fill: "#FFF8E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.09668,
    y: 8.73621,
    width: 1.53866,
    height: 8.46264,
    rx: 0.235073,
    transform: "rotate(-90 4.09668 8.73621)",
    fill: "#FFF8E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_983_3273",
    x1: 0.94043,
    y1: 7.91511,
    x2: 15.4597,
    y2: 8.48181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98E15F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02E3AD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_983_3273"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.00195312,
    width: 16.3987,
    height: 16.3987,
    rx: 8.19936,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.a96187a6e8bb12241b497bde4fd67646.svg";
export { ForwardRef as ReactComponent };